import {ChangeDetectorRef, Component, DestroyRef, Inject, OnInit, ViewChild} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AppointmentDialogDataV2Model} from '../models/edit-appoitment-data-model';
import {SchedulerService} from '../scheduler.service';
import {Globals} from '../../../globals';
import {MatTabChangeEvent} from '@angular/material/tabs';
import { DxListComponent } from 'devextreme-angular';
import { AppointmentReason } from '../models/appoitment-model';
import { AppointmentReasonsComponent } from '../../configuration/appointment-reasons/appointment-reasons.component';
import { ColorSchemesService } from '../../configuration/color-schemes/color-schemes.service';
import { UiService } from 'src/app/services/ui.service';

/** Which DevExtreme lists to repaint (this dialog has 2 tabs: New Case vs Existing Case; procList is commented out in template). */
type ProcedureDialogRepaintScope = 'newCase' | 'existingCase' | 'activeTab' | 'all';

@Component({
  standalone: false,
    selector: 'app-edit-appointment-select-procedure-dialog',
    templateUrl: './edit-appointment-select-procedure-dialog.component.html',
    styleUrls: ['./edit-appointment-select-procedure-dialog.component.scss']
})
export class EditAppointmentSelectProcedureDialogComponent implements OnInit {

    @ViewChild('procList') procList: DxListComponent;
    @ViewChild('tdoListReasons') tdoListReasons: DxListComponent;
    @ViewChild('caseList') caseList: DxListComponent;
    @ViewChild('caseProcList') caseProcList: DxListComponent;

    //colorSchemes: ColorSchemeDataModel[] = [];
    patientCases: any[];
    caseProcedures: any[]; 
    patientCaseProcedures: any[] =[];
    isLoading = false;

    tabSelectedIndex: number = 0;

    selectedCase: any;

    selectedNewAppCaseProcedureID: string  ;
    selectedProcItemKeys: string[] = [];
    selectExstPatientCaseId : string ;
    selectExstCaseWorkItemId: string ;
    selectExstProcedureName: string ;

    selectEnumCaseFollowupReasonID: string ;
    selectEnumCaseFollowupReason: string ;
    appointmentReasonsList: AppointmentReason[] = [];
    selectedAppointmentReason: AppointmentReason;

    private destroyed = false;
    private repaintTimer: ReturnType<typeof setTimeout> | undefined;

    constructor( @Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataV2Model,
                 private readonly dialogRef: MatDialogRef<EditAppointmentSelectProcedureDialogComponent>,
                 private readonly dialog: MatDialog,
                 private readonly schedulingService: SchedulerService,
                 public globals: Globals,
                 private readonly cdr: ChangeDetectorRef,
                 private readonly destroyRef: DestroyRef,
                 private readonly colorSchemeService: ColorSchemesService,
                 private readonly uiService: UiService
    ) {
        this.destroyRef.onDestroy(() => {
            this.destroyed = true;
            if (this.repaintTimer !== undefined) {
                clearTimeout(this.repaintTimer);
                this.repaintTimer = undefined;
            }
        });
    }

    /** Dialog + DevExtreme lists under mat-tab often skip the first paint after async loads (post–Angular upgrade). */
    private refreshDialogLists(scope: ProcedureDialogRepaintScope = 'all'): void {
        if (this.destroyed) {
            return;
        }
        this.cdr.detectChanges();
        if (this.repaintTimer !== undefined) {
            clearTimeout(this.repaintTimer);
        }
        this.repaintTimer = setTimeout(() => {
            this.repaintTimer = undefined;
            if (this.destroyed) {
                return;
            }
            this.repaintDxLists(scope);
        });
    }

    private repaintDxLists(scope: ProcedureDialogRepaintScope): void {
        const effective: 'newCase' | 'existingCase' | 'all' =
            scope === 'activeTab'
                ? (this.tabSelectedIndex === 0 ? 'newCase' : 'existingCase')
                : scope;
        if (effective === 'all' || effective === 'newCase') {
            this.tdoListReasons?.instance?.repaint();
        }
        if (effective === 'all' || effective === 'existingCase') {
            this.caseList?.instance?.repaint();
            this.caseProcList?.instance?.repaint();
        }
    }


    ngOnInit() {
        this.isLoading = true;

      this.selectEnumCaseFollowupReasonID= '';
      this.selectEnumCaseFollowupReason='';

        // load patient cases
        this.patientCases = [];

        this.schedulingService.getAllPatientCases( this.data.appointment.PatientId ).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
          if (res){

            const z = JSON.parse(res);

            this.patientCases = z.retcase;
            this.caseProcedures = z.retproc;

            if (this.patientCases.length > 0 ) {
                this.selectedCase = this.patientCases[0];
            }
            this.refreshDialogLists('existingCase');
          }
        });

        this.colorSchemeService.getColorSchemes(true).subscribe((colorSchemeData) => {
          
        this.schedulingService.getAppointmentReasons(this.globals.LOCID).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe({
          next: (data) => {
            this.appointmentReasonsList = ((data as AppointmentReason[]) || []).sort((a, b) => (a.ItemOrder || 0) - (b.ItemOrder || 0));
            //console.log('appointmentReasonsList: ', this.appointmentReasonsList);

            this.isLoading = false;
            this.refreshDialogLists('newCase');
          },
          error: (error) => {
            console.error('Error loading appointment reasons:', error);
            // Fallback to mock data if service fails
        
            this.isLoading = false;
            this.refreshDialogLists('newCase');
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }, error => {
        console.error('Error loading color schemes:', error);
        this.isLoading = false;
      });
    }


    onReasonSelectionChanged(e: any) {

      this.selectedAppointmentReason = e.addedItems[0];

      this.selectedNewAppCaseProcedureID = e.addedItems[0].CaseProcedureId;

      // Automatically select the corresponding procedure in procList
      if (this.selectedNewAppCaseProcedureID) {
        // Find the procedure that matches the selected CaseProcedureId
        const matchingProcedure = this.data.procedures.find(proc => proc.CaseProcedureId === this.selectedNewAppCaseProcedureID);
        if (matchingProcedure) {
          // Update the selected item keys array for binding
          this.selectedProcItemKeys = [this.selectedNewAppCaseProcedureID];
          this.selectExstProcedureName = matchingProcedure.ProcedureName;
        }
      }
    }
    

  onProcSelectionChanged(e: any ) {
    this.selectedNewAppCaseProcedureID = e.addedItems[0].CaseProcedureId;
    this.selectedProcItemKeys = [e.addedItems[0].CaseProcedureId];
    this.selectExstProcedureName = e.addedItems[0].ProcedureName;
  }

  selectedTooth ="";
  onCaseSelectionChanged(e: any) {
      // filter ARRY FOR CASE PROCEURES
    const reasonId = e.addedItems[0].AppointmentReasonID;
    if (reasonId) {
      this.selectedAppointmentReason = this.appointmentReasonsList.find(f => f.ApptReasonId.toLowerCase() === reasonId.toLowerCase());
    }
    else {
      this.selectedAppointmentReason = this.appointmentReasonsList[0];
    }
    this.selectedTooth= e.addedItems[0].Teeth;

    this.patientCaseProcedures = this.caseProcedures.filter(f => f.PatientCaseId === e.addedItems[0].PatientCaseID);

    this.selectExstPatientCaseId = undefined;
    this.selectExstCaseWorkItemId = undefined;
    this.refreshDialogLists('existingCase');
  }

  onCaseProcSelectionChanged(e : any)  {
    this.selectExstPatientCaseId =e.addedItems[0].PatientCaseId;
    this.selectExstCaseWorkItemId = e.addedItems[0].CaseWorkItemId ;
    this.selectExstProcedureName = e.addedItems[0].ProcedureName;
  }

    tabChanged(tabChangeEvent: MatTabChangeEvent) {
        this.tabSelectedIndex = tabChangeEvent.index;
        this.refreshDialogLists('activeTab');
    }

    onOkClick() {
      if (!this.selectedAppointmentReason) {
        this.uiService.displayMessage('warning', 'Please select a reason.');
        return;
      }

        switch (this.tabSelectedIndex)
        {
        case 0:
            const ret =  {"type": "new", "CaseProcedureID": this.selectedNewAppCaseProcedureID, "ProcedureName": this.selectExstProcedureName,
            "Reason": this.selectedAppointmentReason.Description, "ReasonId": this.selectedAppointmentReason.ApptReasonId, "ReasonLength": this.selectedAppointmentReason.ApptLengthInMinutes
            };
            this.dialogRef.close(ret);
            break;
        case 1:
            if( this.selectExstPatientCaseId == undefined || this.selectExstCaseWorkItemId ==undefined )
            {

              this.uiService.displayMessage('warning', 'Please select Case and Procedure !');
             break;
            }
            const retp  =  {"type": "case", "PatientCaseId": this.selectExstPatientCaseId, "CaseWorkItemId": this.selectExstCaseWorkItemId, "ProcedureName": this.selectExstProcedureName + '(' + this.selectEnumCaseFollowupReason + ')', "EnumCaseFollowupReason":  '#'+this.selectedTooth+ ' '+ this.selectEnumCaseFollowupReason,
              "Reason": this.selectedAppointmentReason.Description, "ReasonId": this.selectedAppointmentReason.ApptReasonId, "ReasonLength": this.selectedAppointmentReason.ApptLengthInMinutes
            };

            this.dialogRef.close(retp);
            break;

        default:
          //
          this.dialogRef.close(true);
        }
    }
    onCancelClick()  {

      const ret =  {"type": "cancel"};
      this.dialogRef.close(ret);
    }


  onDropdownItemSelected(e) {
    this.selectEnumCaseFollowupReason =  e.ItemDisplayValue;
  }

  onEditReasonClick() {
    console.log('Edit reason button clicked');
    // Add your edit reason logic here
    this.dialog.open(AppointmentReasonsComponent, {
      width: '700px',
      height: '700px',
      panelClass: 'dialog',
      data: {
        editMode: true,
        selectedAppointmentReason: this.selectedAppointmentReason
      }
    }).afterClosed().subscribe((res) => {
      console.log('Edit reason dialog closed', res);

       // reload appointment reasons list
       this.appointmentReasonsList=[];
       this.schedulingService.getAppointmentReasons(this.globals.LOCID).pipe(
           takeUntilDestroyed(this.destroyRef)
       ).subscribe((reload: AppointmentReason[]) => {
        this.appointmentReasonsList = reload;
        this.refreshDialogLists('newCase');
       });
    });
  }

  
  getBackgroundColor(colorSchemeID: string) {
    if (!colorSchemeID) {
      return "white";
    }
    return this.colorSchemeService.getBackgroundColor(colorSchemeID) || "white";
  }

  getForeColor(colorSchemeID: string) {
    if (!colorSchemeID) {
      return "black";
    }
    return this.colorSchemeService.getForeColor(colorSchemeID) || "black";
  }
}
